/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_property-desc.js
// module id = 81
// module chunks = 60